/*
 * @Author: 山白 geweijie@cai-inc.com
 * @Date: 2025-04-03 15:52:38
 * @LastEditors: 山白 geweijie@cai-inc.com
 * @LastEditTime: 2025-04-22 09:46:07
 * @FilePath: /zcy-claim-front/src/common/models/global.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { DIST_KEY } from 'src/common/models/config/index';
import { getDistConfig, queryElectronicArchivesSetting } from '../services';

/**
 * 全局配置
 */
export default {
  namespace: 'global',
  state: {
    // ====== 业务区划标识 【后续只要在 DIST_KEY 中添加新的类型就可以，不需要在这里继续调整】======
    isZcy: false, // 政采云标识
    isWenlingGuotou: false, // 数理通表示
    isJiaxingGongan: false, // 嘉兴公安
    isNbDistrict: false, // 宁波区划(包括下辖)标识
    isScDistrict: false, // 上城区划
    isZhoushanGongan: false, // 舟山公安
    isShengZhouYiLiao: false, // 嵊州医疗
    enableYWHT: false, // 开启义乌合同
    isHzDistrict: false, // 杭州区划
    operatorEnableAlias: false, // 操作人是否显示别名
    isEnableGovBudget: false, // 是否启用政府全面预算
    isQuZhouYiLiao: false, // 衢州医疗
    // ====== 功能标识 ======
    isDistrictReady: false, // 标识区划配置是否加载完成
    // 电子档案配置
    electronicArchivesSetting: null,
    // 金控配置
    isJinKong: false,
  },
  effects: {
    *getDistConfig({ payload }, { call, put, select }) {
      try {
        const isDistrictReady = yield select(state => state.global.isDistrictReady);
        // 如果已经加载过，不再加载
        if (isDistrictReady) return;
        const res = yield call(getDistConfig, payload);
        // 判断是否开启
        const isTrue = key => String(res?.[key]) === 'true';

        const pay = {}; // { isDistrictReady: true };
        DIST_KEY.forEach(item => {
          pay[item.key] = isTrue(item.key);
        });
        pay.isDistrictReady = true;
        yield put({
          type: 'update',
          payload: pay,
        });
      } catch (error) {
        console.log(error);
        yield put({
          type: 'update',
          payload: {
            isDistrictReady: false,
          },
        });
      }
    },
    *getElectronicArchivesSetting({ payload }, { call, put, select }) {
      const electronicArchivesSetting = yield select(
        state => state.global.electronicArchivesSetting,
      );
      try {
        if (electronicArchivesSetting) return;
        const res = yield call(queryElectronicArchivesSetting, payload);
        if (res) {
          yield put({
            type: 'update',
            payload: {
              electronicArchivesSetting: {
                ...res,
                allowedFileTypes:
                  res?.archiveActive && res?.fileTypeCheckEnabled ? res?.allowedFileTypes : null,
                maxFileSize:
                  res?.archiveActive && res?.fileSizeCheckEnabled ? res?.maxFileSize : null,
              },
            },
          });
        }
      } catch (error) {
        yield put({
          type: 'update',
          payload: {
            electronicArchivesSetting: null,
          },
        });
      }
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
